<template>
    <el-collapse v-model="activeName" accordion>
        <el-collapse-item :title="section.name" name="1" class="section-accordion">
            <template slot="title">
                <div v-if="!section.parent_id">
                    <span>{{ section.name }}</span>
                    <el-progress
                        v-if="!isRSA"
                        :format="
                            (percentage) => `(${allFilledQuestions.length}/${allQuestions.length})`
                        "
                        :percentage="(allFilledQuestions.length / allQuestions.length) * 100"
                    ></el-progress>
                </div>
                <span v-else>{{ section.name }}</span>
            </template>
            <question
                v-for="question in section.questions"
                :question="question"
                :key="question.id"
                :id="'q' + question.id"
                :visitId="visitId"
                :form="form"
                :sections="sections"
                :questions="section.questions"
                :section="section"
                :calcMethod="calculatedQuestions(question)"
                :visit="visit"
            />

            <template v-for="sectionGroup in visibleSectionGroupList">
                <repeatableSection
                    v-if="sectionGroup[0].is_repeatable"
                    v-show="
                        (isInSharedMode && sectionGroup[0].isVisibleInSharedMode) || !isInSharedMode
                    "
                    :key="sectionGroup[0].id + '_sctn'"
                    :id="sectionGroup[0].id + '_sctn'"
                    :referenceSection="sectionGroup[0]"
                    :currentSection="currentRepeatableSection"
                    :sections="sections"
                    :repeatableSections="sectionGroup"
                    :activeQuestion="activeQuestion"
                    :activeSection="activeSection"
                    :visitId="visitId"
                    :form="form"
                    @onExpandSection="expandPanel"
                    :visit="visit"
                />
                <formSection
                    v-else
                    v-show="
                        (isInSharedMode && sectionGroup[0].isVisibleInSharedMode) || !isInSharedMode
                    "
                    class="ml-1"
                    :id="sectionGroup[0].id + '_sctn'"
                    :sections="sections"
                    :section="sectionGroup[0]"
                    :key="sectionGroup[0].id + '_' + sectionGroup[0].form_ques_data_group_id"
                    :activeQuestion="activeQuestion"
                    :activeSection="activeSection"
                    :visitId="visitId"
                    :form="form"
                    @onExpandSection="expandPanel"
                    :visit="visit"
                />
            </template>
        </el-collapse-item>
    </el-collapse>
</template>

<script>
import eventBus from '@app/src/lib/helpers/eventbus';
import { applyClientCalculatedData } from '@app/src/lib/util/section';
import splitSectionsMixin from '@app/src/mixins/split-sections';
import Form from '@/data/Form';
import { calculatedQuestions } from '@app/src/lib/calculator/formMethods';
import repeatableSection from './repeatable-section.vue';
import questionComponent from './question.vue';

export default {
    name: 'formSection',
    mixins: [splitSectionsMixin],
    props: {
        sections: { type: Array, required: true },
        section: { type: Object, required: true },
        activeSection: null,
        activeQuestion: null,
        visitId: null,
        form: { type: Form, required: true },
        visit: null,
    },
    components: {
        question: questionComponent,
        repeatableSection,
    },
    data() {
        return {
            activeName: 1,
        };
    },
    mounted() {
        eventBus.$on('sectionHided', (message) => {
            const selection = this.section.id === message.ref_id ? this.section : null;

            if (selection) {
                // section icindeki sorular
                for (
                    let i = 0, l = selection.questions && selection.questions.length;
                    i < l;
                    i += 1
                ) {
                    selection.questions[i].data.return_value = '';
                    this.form.setHiddenQuestions(selection.questions[i].id);
                    selection.questions[i].visible = false;
                }

                const subSections = this.sections.filter((item) => item.parent_id === selection.id);
                // sub section icindeki sorular ?
                this.setQuestionsNull(subSections);
            }
        });

        /*
        TODO:
            Section shown oldugu zaman form icerisinde gizli kalmasi gereken bazi elementleri de shown yapiyoruz
            ve bunu ayirt edemiyoruz, burada bu eventleri kesinlikle rule bazinda ve section karistirmadan yapmak gerekecek
            simdilik event yakalamayacagiz, hide ve showu comment out birakiyoruz.

        eventBus.$on('sectionShown', (message) => {
            const selection = this.section.id === message.ref_id ? this.section : null;

            if (selection) {
                // section icindeki sorular
                for (
                    let i = 0, l = selection.questions && selection.questions.length;
                    i < l;
                    i += 1
                ) {
                    selection.questions[i].visible = true;
                    this.form.setHiddenQuestions(selection.questions[i].id, true);
                }

                const subSections = this.sections.filter((item) => item.parent_id === selection.id);
                // sub section icindeki sorular ?
                this.setQuestionsToggleVisiblity(subSections, true);
            }
        });
        */

        const $section = document.getElementById(`${this.section.id}_sctn`);

        if ($section) {
            $section.style.setProperty(
                'display',
                this.section.default_visibility &&
                    ((this.isInSharedMode && this.section.isVisibleInSharedMode) ||
                        !this.isInSharedMode)
                    ? 'block'
                    : 'none',
                'important'
            );
            /*
            TODO:
                Yukardaki sectionshown eventindeki gibi burada da shown olmasi gereken bazi questionlar hide olmakta ve validasyonu bozmaktadir.
            if (!this.section.default_visibility) {
                eventBus.$emit('sectionHided', { ref_id: this.section.id, visible: 0 });
            }
            */
        }
    },
    methods: {
        calculatedQuestions(question) {
            const formQuestions = []
                .concat(this.form.questions)
                .concat(this.sections.reduce((acc, curVal) => acc.concat(curVal.questions), []));
            return calculatedQuestions(question, formQuestions);
        },
        expandPanel() {
            this.activeName = '1';
            this.$emit('onExpandSection');
        },
        setQuestionsNull(sectionsArray) {
            for (let i = 0, l = sectionsArray && sectionsArray.length; i < l; i += 1) {
                const section = sectionsArray[i];

                if (section) {
                    // section icindeki sorular
                    for (let j = 0, k = section?.questions?.length; j < k; j += 1) {
                        section.questions[j].data.return_value = '';
                    }

                    this.setQuestionsNull(
                        this.sections.filter((item) => item.parent_id === section.id)
                    );
                }
            }
        },
        setQuestionsToggleVisiblity(sectionsArray, visible) {
            for (let i = 0, l = sectionsArray && sectionsArray.length; i < l; i += 1) {
                const section = sectionsArray[i];

                if (section) {
                    // section icindeki sorular
                    for (let j = 0, k = section?.questions?.length; j < k; j += 1) {
                        section.questions[j].visible = visible;
                        this.form.setHiddenQuestions(section.questions[i].id, visible);
                    }

                    this.setQuestionsToggleVisiblity(
                        this.sections.filter((item) => item.parent_id === section.id),
                        visible
                    );
                }
            }
        },
        getAllChildSections(section, allChildSections = []) {
            section = section || this.section;
            this.sections.forEach((sect) => {
                if (sect.parent_id == section.id) {
                    allChildSections.push(sect);
                    this.getAllChildSections(sect, allChildSections);
                }
            });

            return allChildSections;
        },
    },
    computed: {
        isRSA() {
            return this.$store.getters.isRSA;
        },
        rootSections() {
            const rootSections = this.sections.filter(
                (item) =>
                    item.parent_id === this.section.id &&
                    (item.parent_form_ques_data_group_id === this.section.form_ques_data_group_id ||
                        (!item.parent_form_ques_data_group_id &&
                            !this.section.form_ques_data_group_id))
            );

            return applyClientCalculatedData(rootSections);
        },
        visibleSectionGroupList() {
            return this.sectionsGroupList.filter(
                (sectionGroup) =>
                    (this.isInSharedMode && sectionGroup[0].isVisibleInSharedMode) ||
                    !this.isInSharedMode
            );
        },
        isInSharedMode() {
            return this.$route.meta.name === 'share';
        },
        allQuestions() {
            const allChildSections = this.getAllChildSections(this.section);
            let questions = (this.section.questions || []).filter(
                (item) => item.visible && !item.isLabel
            );

            allChildSections.forEach((sect) => {
                questions = questions.concat(
                    sect.questions.filter((item) => item.visible && !item.isLabel)
                );
            });

            return questions;
        },
        allFilledQuestions() {
            return this.allQuestions.filter((question) => question.data.return_value);
        },
    },
    watch: {
        activeSection(id) {
            if (this.section.id === id) {
                this.expandPanel();
            }
        },
    },
};
</script>

<style lang="scss">
.section-accordion {
    .el-collapse-item__header {
        line-height: inherit !important;
    }
}

.line-clamp {
    .cell {
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
}

.action-column {
    .cell {
        overflow: visible;
    }

    .action-buttons {
        display: flex;
        justify-content: flex-start;
    }
}

.btn-add-new {
    margin-top: 20px;
}

.form-head {
    margin: 20px 0;
    font-size: 17px;
}

.error-message {
    color: #f00;
}
</style>
